export const coreHotelCfarOffersThemeVars = (vars?: {
  cancellationPolicyContentItemViewTermsLinkColor?: string;
}) => ({
  "core-cfar-hotels-lodging-cancellation-policy-content-item-view-terms-link-color":
    vars?.cancellationPolicyContentItemViewTermsLinkColor ?? "#1169D9",
});
